export default __webpack_public_path__ + "static/media/LoginPage.ba68e4e7.jpeg";